require('./OKHeaderSubPageValue.scss');

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';

const { FormattedText, hasTranslation, getLanguage } = require('core/i18n').i18n;

import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

const OKHeaderSubPageValue = props => {
  const { value, textKey, isAmountType, inverted } = props;

  let valueComponent;

  const valueClassNames = classNames('ok-header-subpage-value__value', {
    'ok-header-subpage-value__first': inverted,
  });

  if (!!value) {
    const parsedValue = isAmountType ? getPlainAmountObject(value) : value;
    valueComponent = isAmountType ? (
      <OneLineSymbolAmount
        amountObject={parsedValue}
        className={valueClassNames}
        language={getLanguage()}
        amountObjectFormatted={formatAmountObject(parsedValue, true)}
      />
    ) : (
      <div className={valueClassNames}>{value}</div>
    );
  } else {
    valueComponent = <div className={valueClassNames}>-</div>;
  }

  const textClassNames = classNames('ok-header-subpage-value__text', {
    'ok-header-subpage-value__first': !inverted,
  });

  const content = [
    <div key="text" className={textClassNames}>
      {hasTranslation(textKey) ? <FormattedText value={textKey} /> : textKey}
    </div>,
    valueComponent,
  ];

  return <div className="ok-header-subpage-value">{inverted ? content.reverse() : content}</div>;
};

OKHeaderSubPageValue.propTypes = {
  textKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isAmountType: PropTypes.bool,
  inverted: PropTypes.bool,
};

OKHeaderSubPageValue.defaultProps = {
  textKey: '',
  value: '',
  isAmountType: false,
  inverted: false,
};

export { OKHeaderSubPageValue };
